import React from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ExamQuestionModal from "./ExamQuestionModal";
import StudentExamModal from "./StudentExamModal";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [ExamName, setExamName] = React.useState(FetchData.meta.exam_name_order)
  const [ExamId, setExamID] = React.useState(FetchData.meta.exam_id_order)
  const [ExamModal, setExamModal] = React.useState(false)
  const [StudentID, setStudentID] = React.useState(FetchData.meta.student_id_order)
  const [StudentEmail, setStudentEmail] = React.useState(FetchData.meta.student_email_order)
  const [StudentPhoneNumber, setStudentPhoneNumber] = React.useState(FetchData.meta.student_phone_order)
  const [StudentUserName, setStudentUserName] = React.useState(FetchData.meta.student_username_order)
  const [StudentModal, setStudentModal] = React.useState(false)
  const [PaidAmount, setPaidAmount] = React.useState(FetchData.meta.paid_amount)
  const [VerificationStatus, setVerificationStatus] = React.useState(FetchData.meta.verification_status)
  const [VerificationMethod, setVerificationMethod] = React.useState(FetchData.meta.verification_method)
  const [VerificationDate, setVerificationDate] = React.useState(FetchData.meta.verification_date)
  const [VerificationID, setVerificationID] = React.useState(FetchData.meta.verification_id)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": `${StudentID}-${ExamId}`,
      "status": "publish",
      "meta": {
        "course_name_order": ExamName,
        "course_id_order": `${ExamId}`,
        "student_id_order": `${StudentID}`,
        "student_email_order": StudentEmail,
        "student_phone_order": `${StudentPhoneNumber}`,
        "student_username_order": StudentUserName,
        "paid_amount": `${PaidAmount}`,
        "verification_status": VerificationStatus,
        "verification_method": VerificationMethod,
        "verification_date": `${VerificationDate}`,
        "verification_id": `${VerificationID}`
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_question_bank_exam_orders)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Batch Added Successfully")
          history.push(`${slugs.order_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_question_bank_exam_orders, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`Order edited Successfully`)
        }).catch(err => {
            setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Order Information</center></h4>
          <table>
            <tbody>
              <tr >
                <td className="col-3">Exam Name</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setExamModal(true) }}>
                  <div className="input-common">
                    {ExamName}&nbsp;
                  </div>

                </td>
              </tr>
              <tr>
                <td className="col-3">Exam ID</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setExamModal(true) }}>
                  <div className="input-common">
                    {ExamId}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Student ID</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setStudentModal(true) }}>
                  <div className="input-common">
                    {StudentID}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Student Name</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setStudentModal(true) }}>
                  <div className="input-common">
                    {StudentUserName}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Student Phone Number</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setStudentModal(true) }}>
                  <div className="input-common">
                    {StudentPhoneNumber}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Student Email</td>
                <td className="col-6" style={{ cursor: "pointer" }}
                  onClick={() => { setStudentModal(true) }}>
                  <div className="input-common">
                    {StudentEmail}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Paid Amount</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PaidAmount} placeholder="Paid Amount"
                    onChange={(event) => { setPaidAmount(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Verification Status</td>
                <td className="col-6">
                  <CustomButton setData={setVerificationStatus} Data={VerificationStatus} DataValue={"Unverified"} />
                  <CustomButton setData={setVerificationStatus} Data={VerificationStatus} DataValue={"Verified"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Verification Method</td>
                <td className="col-6">
                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Esewa"} />
                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Khalti"} />
                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Manual"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Verification Date</td>
                <td className="col-6">
                  <input className="input-common"
                    value={VerificationDate} placeholder="Verification Date"
                    onChange={(event) => { setVerificationDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Verification ID</td>
                <td className="col-6">
                  {VerificationID.includes("https:") ?
                    <a href={VerificationID} target="_blank">
                      <img src={VerificationID} style={{ height: "200px" }} />
                    </a>
                    :
                    <input className="input-common"
                      value={VerificationID} placeholder="Verification ID"
                      onChange={(event) => { setVerificationID(event.target.value) }}
                    />
                  }
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Order
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        ExamModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setExamModal(false)
                  }}
                >X</div>
                <ExamQuestionModal
                  setExamName={setExamName} setExamModal={setExamModal}
                  ExamId={ExamId} setExamID={setExamID}

                />
              </div>
            </div>
          </div>
        </section>
      }
      {
        StudentModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setStudentModal(false)
                  }}
                >X</div>
                <StudentExamModal
                  setStudentID={setStudentID}
                  setStudentEmail={setStudentEmail}
                  StudentID={StudentID}
                  setStudentPhoneNumber={setStudentPhoneNumber}
                  setStudentUserName={setStudentUserName}
                  setStudentModal={setStudentModal}
                />
              </div>
            </div>
          </div>
        </section>
      }
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div>
  )

}